module.exports = __webpack_public_path__ + "img/trackbar.11e87fe9.gif";